import React from 'react';

function NavLinks() {
    return (
        <div className="nav-links">
            <div><h2>On this page</h2></div>
            <ol>
                <li><a href="#when-to-apply">When to apply</a></li>
                <li><a href="#how-to-apply">How to apply</a></li>
                <li><a href="#common-mistakes">Common Mistakes to Avoid</a></li>
                <li><a href="#benefits-of-help">Benefits of Getting Help</a></li>
                <li><a href="#related">Related</a></li>
            </ol>
        </div>
    );
}

export default NavLinks;